module.exports = __webpack_public_path__ + "fonts/48f8a84416de59f5f56a0a5377a6bde9-Audiowide-Regular.eot";